howspace.login = (() => {
    'use strict';

    $('.haka-login-btn').on('click', e => {
        const btn = $(e.currentTarget);
        const entityIdSelect = $('.haka-entity-id');
        const entityId = entityIdSelect.val();
        if (entityId) {
            window.location = btn.data('href') + '&target_entity_id=' + encodeURIComponent(entityId);
        } else {
            real.input.focus(entityIdSelect);
        }
    });

    (async () => {
        const emailInput = $('#email');
        if (emailInput.length > 0 && emailInput.prop('autocomplete').indexOf('webauthn') !== -1) {
            const errorFn = async function () {
                howspace.form.markInvalidField(emailInput);
            };
            await howspace.webauthn.conditionalLogin(errorFn);
        }
    })();

    const passkeyLoginBtn = $('.passkey-login-btn');
    if (passkeyLoginBtn.length > 0 && howspace.webauthn.isSupported()) {
        // The button is rendered hidden so that browsers without WebAuthn never see a dead control.
        passkeyLoginBtn.removeClass('d-none');
        $('.passkey-login-separator').removeClass('d-none');
        passkeyLoginBtn.on('click', async e => {
            const btn = $(e.currentTarget);
            real.button.loading(btn, $('.login-form'));

            await howspace.webauthn.login(() => {
                real.button.reset(btn, $('.login-form'));
                real.notification.show(howspace.translate('login_error_passkey_failed'), 'danger');
            });
        });
    }

    const logoImg = document.querySelector('.logo-image');
    if (logoImg) {
        // If logo image fails to load we just remove it to avoid broken image.
        if (logoImg.complete && logoImg.naturalWidth === 0 && logoImg.naturalHeight === 0) {
            logoImg.remove();
        }
        logoImg.addEventListener('error', () => {
            logoImg.remove();
        }, {once: true});
    }

    return {
        resetLoginButton: (btn) => {
            let emailInput = $('#email');
            howspace.form.markInvalidField(emailInput);
            real.button.reset(btn, $('.login-form'));
            setTimeout(function() {
                emailInput.attr('disabled', false);
                emailInput.removeClass('disabled');
                real.input.focus(emailInput);
                // Clear possible previous token so captcha can be triggered again
                $('#cf-token').val('');
            }, 0);
        }
    };
})();
